import { DatePipe } from "@angular/common";

export class LocalDateTimeHelper {
    // Returns current date string in M/d/yyyy h:mma format
    static getCurrentDateString(now: Date): string {
        const datePipe = new DatePipe('en-US');
        return datePipe.transform(now, 'M/d/yyyy h:mma') || '';
    }
}
